import { requestWithAuth } from "@/utils/authUtils";

const SessionInsightsService = {
  async generateInsight(payload) {
    try {
      return await requestWithAuth(
        "/practice-session-stats/insights",
        "POST",
        payload
      );
    } catch (error) {
      console.error("Error while generating session insight:", error);
      throw error;
    }
  },
};

export default SessionInsightsService;
